export default "__VITE_ASSET__eyckHw3eLYpWyD_hCZ4eHg__"